<template>
	
	<div class="card card--border checklist">
		
		<div class="checklist__title-bar">
			
			<div class="checklist__handle"></div>
			
			<div class="checklist__title-wrapper">
				<input type="text" class="checklist__title" v-model="checklist.title" placeholder="Title" @change="onChangeChecklistTitle">
			</div>
			
			<el-dropdown class="checklist__actions" @command="onClickMenuItem" style="float: right;">
				<el-button class="ticket__menu ticket__menu--more" icon="el-icon-more"></el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="duplicate-list">Duplicate</el-dropdown-item>
					<el-dropdown-item command="delete-list">Delete</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			
		</div>
		
		<el-progress class="checklist__progress" v-if="checklist.items.length" :text-inside="true" :percentage="percentCompleted" :status="status"></el-progress>
		
		<p v-if="checklist.items.length === 0" class="checklist__empty">There are no items in this list.</p>
		
		<draggable v-else class="checklist__items" v-model="checklist.items" handle=".checklist__item-handle" group="items" @end="onUpdateItemOrder">
			<div v-for="(item, index) in checklist.items" class="checklist__item" :key="index">
				<div class="checklist__item-handle"></div>
				<div class="checklist__checkbox" :class="{ 'checklist__checkbox--checked': item.checked }" @click="onClickCheckbox(item)" :key="index">
					<ion-icon class="checklist__checkbox-icon" name="checkmark"></ion-icon>
				</div>
				<div class="checklist__item-input-outer">
					<el-button class="checklist__delete-item" :class="{ 'hidden': item.checked }" type="text" icon="el-icon-close" size="small" @click="onClickDeleteItem(item, index)"></el-button>
					<el-input ref="checklist-item-input" type="textarea" class="checklist__item-input" :class="{ 'checklist__item-input--checked': item.checked }" placeholder="Description" v-model="item.description" @change="onChangeChecklistItemDescription(item)" autosize></el-input>
					<!--<textarea type="text" class="checklist__item-input" :class="{ 'checklist__item-input--checked': item.checked }" v-model="item.description" placeholder="New Item"></textarea>-->
				</div>
			</div>
		</draggable>
		
		<el-button type="text" size="small" style="padding: 5px 10px;" icon="el-icon-plus" round @click="onClickAddItem">Add Item</el-button>
		
	</div>
	
</template>

<script>
	
	const randomstring = require("randomstring");
	
	import Draggable from "vuedraggable";
	
	export default {
		
		props: {
			index: Number,
			checklist: Object,
		},
		
		components: { Draggable },
		
		methods: {
			
			onUpdateItemOrder(e) {
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "reorder-items" });
			},
			
			onChangeChecklistTitle(e) {
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "update-list", list: this.checklist });
			},
			
			onChangeChecklistItemDescription(item) {
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "update-item", item: item });
			},
			
			onClickMenuItem(action) {
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: action, index: this.index });
			},
			
			onClickCheckbox(item) {
				// Toggle checkbox.
				item.checked = !item.checked;
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "update-item", item })
			},
			
			onClickDeleteItem(item, index) {
				// Update local list.
				this.checklist.items.splice(index, 1);
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "delete-item", item })
			},
			
			onClickAddItem() {
				// New item data.
				const item = { checklist_id: this.checklist.id, public_id: randomstring.generate(5), description: "", checked: false };
				// Update local list.
				this.checklist.items.push(item);
				// Trigger an event so that we can handle it, eg update a remote database.
				this.$emit("event", { name: "add-item", item });
				// Focus the new element.
				setTimeout(() => {
					const lastIndex = (this.$refs["checklist-item-input"].length - 1);
					const lastInput = this.$refs["checklist-item-input"][lastIndex];
					lastInput.$refs.textarea.focus();
				}, 100);
			}
			
		},
		
		computed: {
			
			percentCompleted() {
				const completed = this.checklist.items.filter((a) => a.checked);
				return 100 * (completed.length / this.checklist.items.length);
			},
			
			status() {
				return this.percentCompleted === 100 ? "success" : "primary";
			},
			
		},
		
	}
	
</script>

<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/components/Checklist.vue